import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Home from "../Home/Home";
import Dashboard from "../Dashboard/Dashboard";
import Login from "../Login/Login";
import AppIndex from "../AppIndex/AppIndex";
import Archive from "../Archive/Archive";
import MyUsersApps from "../MyUsersApps/MyUsersApps";
import AppDetail from "../AppDetail/AppDetail";
import Inbox from "../Inbox/Inbox";
import Nist from "../Nist/Nist";
import Users from "../Users/Users";
import Billing from "../Billing/Billing";
import Settings from "../Settings/Settings";
import NewUser from "../NewUser/NewUser";
import MicrosoftCallback from "../MicrosoftSignIn/MicrosoftCallback";
import FAQ from "../FAQ/FAQ";
import ManualUpload from "../ManualUpload/ManualUpload";
import Tags from "../Tags/Tags";
import ForgotPassword from "../ResetPassword/ForgotPassword";
import ResetPassword from "../ResetPassword/ResetPassword";
import Reporting from "../Reporting/Reporting";
import TeamsAppDetail from "../TeamsAppDetail/TeamsAppDetail";
import ChronusAppDetail from "../ChronusAppDetail/ChronusAppDetail";
import TeamsAppIndex from "../TeamsAppIndex/TeamsAppIndex";
import UsersReport from "../UsersReport/UsersReport";
import NewsAdmin from "../NewsAdmin/NewsAdmin";

const ProtectedRoute = ({
  isAllowed,
  redirectPath = "/login",
  children,
  setShowLoading,
}) => {
  if (!isAllowed) {
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet setShowLoading={setShowLoading} />;
};

export default function AppRoutes({
  userLoggedIn,
  setShowLoading,
  queryClient,
  isConnected,
}) {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route
        path="/login"
        element={<Login setShowLoading={setShowLoading} />}
      />
      <Route path="/newuser" element={<NewUser />} />
      <Route path="/auth/microsoft/callback" element={<MicrosoftCallback />} />
      <Route
        path="/forgotpassword"
        element={<ForgotPassword setShowLoading={setShowLoading} />}
      />
      <Route
        path="/resetpassword"
        element={<ResetPassword setShowLoading={setShowLoading} />}
      />

      <Route
        element={
          <ProtectedRoute
            setShowLoading={setShowLoading}
            isAllowed={isConnected || localStorage.getItem("tokenmob")}
          />
        }
      >
        <Route
          path="/dashboard"
          element={<Dashboard userLoggedIn={userLoggedIn} />}
        />
        <Route path="/apps" element={<AppIndex userLoggedIn={userLoggedIn} />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/mytags" element={<Tags />} />
        <Route
          path="/myusersapps"
          element={<MyUsersApps queryClient={queryClient} />}
        />
        <Route path="/inbox" element={<Inbox />} />
        <Route path="/vuln" element={<Nist />} />
        <Route path="/reporting" element={<Reporting />} />
        <Route path="/teams-apps" element={<TeamsAppIndex userLoggedIn={userLoggedIn} />} />
        <Route path="/teams-apps/:appId" element={<TeamsAppDetail />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/usersreport" element={<UsersReport userLoggedIn={userLoggedIn} />} />
        <Route path="/admin/news" element={<NewsAdmin userLoggedIn={userLoggedIn} />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/users" element={<Users />} />
        <Route
          path="/upload"
          element={<ManualUpload setShowLoading={setShowLoading} />}
        />
        <Route
          path="/app/:bundleId"
          element={
            <AppDetail
              setShowLoading={setShowLoading}
              userLoggedIn={userLoggedIn}
            />
          }
        />
        <Route path="/teams-app-demo" element={<TeamsAppDetail />} />
        <Route path="/teamsapp/chronus" element={<ChronusAppDetail />} />
      </Route>
      <Route path="*" element={<p>There's nothing here: 404!</p>} />
    </Routes>
  );
}

